import styled from '@emotion/styled'
import { SimpleFormat } from 'shop/utils'

const PartnerDescription = ({
  welcomeMessage,
  welcomeMessageHeader
}: {
  welcomeMessage?: string
  welcomeMessageHeader?: string
}) => {
  const welcomeMessageHasText = !!welcomeMessage?.replace(/<[^>]*>/g, '').trim()

  const welcomeMessageHeaderHasText = !!welcomeMessageHeader
    ?.replace(/<[^>]*>/g, '')
    .trim()

  const hasWelcomeDescription =
    welcomeMessageHasText || welcomeMessageHeaderHasText

  const shouldHaveLineBreak =
    welcomeMessageHeaderHasText && welcomeMessageHeaderHasText

  if (!hasWelcomeDescription) return <Padding />
  return (
    <>
      <Description>
        {welcomeMessageHeaderHasText && (
          <SimpleFormat>{welcomeMessageHeader}</SimpleFormat>
        )}
        {shouldHaveLineBreak && <br />}
        {welcomeMessageHasText && <SimpleFormat>{welcomeMessage}</SimpleFormat>}
      </Description>
    </>
  )
}

const Padding = styled.div(() => ({
  paddingTop: '16px'
}))

const Description = styled.div(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'hidden',
  transition: 'all 200ms ease-in',
  color: theme.colors.textBold,
  fontSize: '8px',
  '& ul': {
    listStyleType: 'revert',
    padding: 'revert'
  },
  '*': {
    margin: '0 !important'
  },
  h1: {
    fontSize: '20px',
    lineHeight: 'normal'
  },
  'h6,p': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal'
  },
  a: {
    color: 'inherit',
    fontWeight: 700
  },
  [theme.mediaQueries.viewport7]: {
    padding: '0 16px',
    fontSize: '10px'
  }
}))

export default PartnerDescription
